import PropTypes from 'prop-types';
import React from 'react';
import _ from 'underscore';
import $ from 'jquery';
import './index.scss';
import Dropdown from '../';

import { countryMap } from 'ui_system/inputs/countryUtils';

class CountryDropdown extends React.PureComponent {
  static displayName = 'CountryDropdown';

  static propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    icon: PropTypes.node,
  };

  static defaultProps = {
    value: null,
    icon: <i className="af-triangle-down-2 icon icon-anyfont" />,
  };

  componentDidMount() {
    const $dropdown = $(this.refs.dropdown);
    const $semUISearch = $('input.search', $dropdown);
    $semUISearch.attr('autocomplete', 'off');
  }

  render() {
    const dropdownProps = {
      name: this.props.name,
      errors: this.props.errors,
      guide_us_only: this.props.guide_us_only,
      options: countryMap,
      value: this.props.guide_us_only ? 'US' : this.props.value,
      placeholder: 'Select Country',
      onChange: this.props.onChange,
      icon: this.props.icon,
      theme: this.props.theme,
      ref: 'dropdown',
      displayOptions: {
        search: true,
      },
      ariaLabelledBy: this.props.ariaLabelledBy,
      ariaLabel: this.props.ariaLabel,
    };
    if (this.props.guide_us_only) {
      // dropdownProps.disabled = true;
      dropdownProps.displayOptions = { search: false };
      dropdownProps.icon = '';
      dropdownProps.options = { US: 'United States' };
    }
    return <Dropdown {...dropdownProps} />;
  }
}

export default CountryDropdown;
